"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _ExportToHtml = _interopRequireDefault(require("./../exporter/ExportToHtml"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Preview = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Preview, _PureComponent);

  function Preview() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Preview.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "preview"
    }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Modal, {
      show: this.props.show,
      onHide: this.props.onClose,
      size: "lg",
      "aria-labelledby": "preview-modal"
    }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Modal.Header, null, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Modal.Title, {
      id: "preview-modal"
    }, "Preview")), /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Modal.Body, null, this.props.editorState ? (0, _ExportToHtml["default"])(this.props.editorState) : /*#__PURE__*/_react["default"].createElement("div", {
      dangerouslySetInnerHTML: {
        __html: this.props.html
      }
    })), /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Modal.Footer, null, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Button, {
      onClick: this.props.onClose,
      className: "float-right"
    }, "Close"))));
  };

  return Preview;
}(_react.PureComponent);

var _default = Preview;
exports["default"] = _default;
module.exports = exports.default;